import {
  api_OpenSalesOrderForCustomerMobileApp,
  api_UpdateSkipRatings,
  api_SubmitRatings,
} from "../../../../connection/api/api-orders";
import { STORE_RATING_POSID } from "../../../../database/store-names";
import { ENCRYPT_STORAGE } from "../../../../config/config";
import { Colors } from "../../../../util/colors";
import React from "react";
import "../../../../styles/css/RateNow.css";

class RateNow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantRating: 0,
      riderRating: 0,
      itemRatings: [],
      items: [],
      Merchant: null,
      DeliveryCharges: null,
      Rider: null,
    };
  }

  async componentDidMount() {
    await this.LoadItemsForRating();
  }

  async LoadItemsForRating() {
    let data = await api_OpenSalesOrderForCustomerMobileApp(this.props.orderId);
    let objdata = JSON.parse(data);
    let objobjdata = JSON.parse(objdata);
    let ObjSalesOrderHeader = objobjdata[1][0];

    this.setState({
      items: objobjdata[0],
      Merchant: ObjSalesOrderHeader.Merchant,
      DeliveryCharges: ObjSalesOrderHeader.DineType,
      Rider: ObjSalesOrderHeader.Rider,
    });
  }

  handleRating = (category, rating, index) => {
    if (category === "merchantRating") {
      this.setState({ merchantRating: rating });
    } else if (category === "riderRating") {
      this.setState({ riderRating: rating });
    } else if (category.startsWith("itemRating_")) {
      const itemIndex = parseInt(category.split("_")[1]);
      const updatedItemRatings = [...this.state.itemRatings];
      updatedItemRatings[itemIndex] = {
        ...updatedItemRatings[itemIndex],
        PID: this.state.items[itemIndex].PID,
        LineID: this.state.items[itemIndex].LineID,
        rating,
      };
      this.setState({ itemRatings: updatedItemRatings });
    }
  };

  renderStars = (category, index) => {
    let currentRating;

    if (category.startsWith("itemRating_")) {
      const itemIndex = parseInt(category.split("_")[1]);
      currentRating = this.state.itemRatings[itemIndex]?.rating || 0;
    } else {
      currentRating = this.state[category] || 0;
    }

    return [1, 2, 3, 4, 5].map((starIndex) => (
      <span
        key={starIndex}
        className={`star ${starIndex <= currentRating ? "filled" : ""}`}
        onClick={() => this.handleRating(category, starIndex, index)}
      >
        {starIndex <= currentRating ? (
          <i className="bi bi-star-fill"></i>
        ) : (
          <i className="bi bi-star-fill"></i>
        )}
      </span>
    ));
  };

  handleSubmitRating = async () => {
    const ratings = {
      merchantRating: this.state.merchantRating,
      riderRating: this.state.riderRating,
      itemRatings: this.state.itemRatings,
    };
    let response = await api_SubmitRatings(ratings, this.props.orderId);

    console.log(response);
    ENCRYPT_STORAGE.setItem(STORE_RATING_POSID, 0);

    this.setState({
      merchantRating: 0,
      riderRating: 0,
      itemRatings: [],
    });
    this.props.onCloseModal();
  };

  handleModalClose = async () => {
    await api_UpdateSkipRatings(this.props.orderId);

    this.setState({
      merchantRating: 0,
      riderRating: 0,
      itemRatings: [],
      items: [],
    });
    this.props.onCloseModal();
  };

  render() {
    const { DeliveryCharges } = this.state;
    const displayRiderRating = DeliveryCharges === 4;

    return (
      <div className="modalbg">
        <div className="modalbody" onClick={(e) => e.stopPropagation()}>
          <h3
            className="cardd"
            style={{
              textAlign: "center",
              backgroundColor: Colors.DarkGreyScale,
            }}
          >
            How would you rate ?
          </h3>
          <div>
            {/* merchant Rating */}
            <div className="card">
              <div className="Hitem-rating-label">MERCHANT RATING</div>
              <div className="item-rating-container">
                <label className="item-rating-label">
                  {this.state.Merchant} <i className="bi bi-shop" />{" "}
                </label>
                <div>{this.renderStars("merchantRating", -1)}</div>
              </div>
            </div>

            {/* Rider Rating */}
            {displayRiderRating && (
              <div className="card">
                <div className="Hitem-rating-label">RIDER RATING</div>
                <div className="item-rating-container">
                  <label className="item-rating-label">
                    {" "}
                    {this.state.Rider} <i className="fa fa-motorcycle" />{" "}
                  </label>
                  <div>{this.renderStars("riderRating", -1)}</div>
                </div>
              </div>
            )}

            {/* Add Item Ratings Section */}
            <div className="card">
              <div className="Hitem-rating-label">ITEM RATING</div>
              {this.state.items.map((item, index) => {
                // Check if item should be skipped based on PID
                if (item.PID === 1224929 || item.PID === 73163) {
                  return null;
                }

                return (
                  <div key={index} className="item-rating-container">
                    <label className="item-rating-label">{item.Desc}</label>
                    <div>{this.renderStars(`itemRating_${index}`, index)}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "fit-content",
                fontWeight: "bold",
                marginTop: "30px",
                marginBottom: "10px",
                textAlign: "center",
                backgroundColor: Colors.DarkGreyScale,
                color: "white",
                padding: 15,
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={this.handleSubmitRating}
            >
              Submit Rating
            </div>

            {/* Close */}
            <span
              onClick={this.handleModalClose}
              style={{
                fontWeight: "bold",
              }}
            >
              No, Thanks
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default RateNow;
